import React from 'react';
import { getCustomerColumnWidth } from '../../adapter/utils';
import { getSysFieldid } from '@platform/api';

function useIndex(Table) {
    return class IndexTable extends React.Component {
        render() {
            let { 
                    indexConfig = {}, 
                    columns = [], 
                    locale, 
                } = this.props,
                { enable = true, customIndexParams = {} } = indexConfig;

            if (enable && columns.length) {
                columns = [{
                    title: <div
                        className='table-next-header-title'
                        fieldid={getSysFieldid('numberindex')}
                    >
                        <span className='table-next-header-content'>
                            {locale['table001'] /*'序号'*/}
                        </span>
                    </div>,
                    key: 'INDEX',
                    attrcode: 'INDEX',
                    width: indexConfig.width ?? 60,
                    isleaf: true,
                    depth: 0,
                    fixed: 'left',
                    resizable: true,
                    selectable: true,
                    mergeInfo: indexConfig.mergeInfo,
                    ...customIndexParams,
                    render: (row, index) => {
                        return <div className='table-cell'>{index + 1}</div>;
                    },
                }, ...columns];
            }
            return (
                <Table {...this.props} columns={columns} />
            );
        }
    };
}

useIndex.displayName = 'useIndex';
useIndex.dependence = [];
useIndex.propsGenerator = function (props) {
    const { indexConfig = {} } = props,
        { enable = true } = indexConfig;

    if (!enable) { return props; }

    const { store, id } = props;

    return {
        ...props,
        indexConfig: {
            ...indexConfig,
            width: getCustomerColumnWidth(store, id, 'INDEX', 60),
        },
    };
};

export default useIndex;